import React from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import BillingTab from "./BillingTab";
import DisbursalTab from "./DisbursalTab";
import { useSpecialistStore } from "../../services/specialist";

const EditPayouts = () => {
  const { specialistId = "" } = useParams();
  const { detail } = useSpecialistStore();
  const [tab, setTab] = React.useState<"billings" | "disbursal">("billings");
  const [specialistName, setSpecialistName] = React.useState("Payouts");
  const [refreshKey, setRefreshKey] = React.useState(0);

  React.useEffect(() => {
    const load = async () => {
      const response = await detail(specialistId);
      const specialist = response?.data;
      setSpecialistName(specialist?.name || "Payouts");
    };
    if (specialistId) {
      load();
    }
  }, [detail, specialistId]);

  return (
    <Layout appBarTitle="Payouts">
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          {specialistName}
        </Typography>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs
            value={tab}
            onChange={(_, value: "billings" | "disbursal") => setTab(value)}
          >
            <Tab value="billings" label="Specialist Billings" />
            <Tab value="disbursal" label="Disbursal" />
          </Tabs>
        </Box>

        {tab === "billings" ? (
          <BillingTab
            specialistId={specialistId}
            onDisbursalCreated={() => {
              setRefreshKey((value) => value + 1);
              setTab("disbursal");
            }}
          />
        ) : (
          <DisbursalTab specialistId={specialistId} refreshKey={refreshKey} />
        )}
      </Paper>
    </Layout>
  );
};

export default EditPayouts;
